<script setup lang="ts">
  import type { JourneyTemplateWithExtraOptions } from '@/types/idf-journey-product'
  import type { OrganizationStroomFieldConfig } from '@/types/organization-config'
  import { FormInput } from '@logistiek-zonder-papier/lzp-library'

  defineProps<{
    fieldConfig: OrganizationStroomFieldConfig
    error?: string | undefined
  }>()

  const journeyTemplate = defineModel<JourneyTemplateWithExtraOptions>({
    required: true,
  })
</script>

<template>
  <FormInput
    :label="fieldConfig.fieldLabel ?? '!!!Label not configured!!!'"
    v-model="journeyTemplate.extraOptions[fieldConfig.key]"
    :error="error"
    :type="fieldConfig.type === 'date' ? 'date' : 'text'"
    :data-validation-error="!!error"
  />
</template>

<style scoped></style>
